// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upload-sourse .el-upload-list[data-v-3de91e88] {\n  height: 200px !important;\n  overflow-y: auto;\n}\n.el-dialog__body[data-v-3de91e88] {\n  padding-top: 16px !important;\n}\n", ""]);
// Exports
module.exports = exports;
